import { connect } from 'react-redux'

import { removeUser, setUser } from './reducer'

const mapStateToProps = (state) => {
    return {
        user: state?.services?.user,
    }
}

const hocUser = (InnerComponent) => connect(mapStateToProps, { setUser, removeUser })(InnerComponent)

export default hocUser
